/* Sepette süreli indirim: sepete ilk ürün eklendiğinde 5 dakikalık sayaç başlar.
   Süre içinde indirim kodu sepete otomatik uygulanır; süre dolunca kaldırılır. */
(function () {
  'use strict';

  var CODE = 'SEPETTE150';
  var DURATION = 5 * 60 * 1000;
  var KEY = 'oxbDeal150';
  var MAX_TRIES = 4;

  var busy = false;
  var tries = 0;
  var lastTry = 0;

  function read() {
    try { return JSON.parse(window.localStorage.getItem(KEY)) || null; } catch (e) { return null; }
  }
  function write(state) {
    try { window.localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
  }
  function parseHTML(text) {
    return new DOMParser().parseFromString(text, 'text/html');
  }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function format(ms) {
    var total = Math.max(0, Math.ceil(ms / 1000));
    return pad(Math.floor(total / 60)) + ':' + pad(total % 60);
  }

  function injectStyles() {
    if (document.getElementById('DealTimerStyles')) return;
    var style = document.createElement('style');
    style.id = 'DealTimerStyles';
    style.textContent =
      '.deal-timer{display:flex;align-items:center;justify-content:space-between;gap:.75rem;margin:0 0 1rem;padding:.75rem 1rem;border-radius:.5rem;background:#3B2A2E;color:#F7F3EE;font-size:.9375rem;line-height:1.35}' +
      '.deal-timer[hidden]{display:none}' +
      '.deal-timer__text strong{font-weight:700}' +
      '.deal-timer__clock{flex:none;font-size:1.25rem;font-weight:700;font-variant-numeric:tabular-nums;letter-spacing:.02em}' +
      '.deal-timer.is-expired{background:#EFE8E0;color:#6E625C}' +
      '.deal-timer.is-expired .deal-timer__clock{display:none}';
    document.head.appendChild(style);
  }

  function sectionIds() {
    var ids = ['cart-count'];
    if (document.getElementById('CartDrawer')) ids.push('cart-drawer');
    var page = document.querySelector('cart-items');
    if (page && page.dataset.section) ids.push(page.dataset.section);
    return ids;
  }

  function render(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      var next = parseHTML(sections['cart-drawer']).getElementById('CartDrawerInner');
      var current = document.getElementById('CartDrawerInner');
      if (next && current) {
        var oldNotice = current.querySelector('[data-cart-notice]');
        var newNotice = next.querySelector('[data-cart-notice]');
        if (oldNotice && newNotice) newNotice.hidden = oldNotice.hidden;
        current.replaceWith(next);
      }
    }
    var page = document.querySelector('cart-items');
    if (page && sections[page.dataset.section]) {
      var nextItems = parseHTML(sections[page.dataset.section]).querySelector('cart-items');
      if (nextItems) page.innerHTML = nextItems.innerHTML;
    }
  }

  function setDiscount(code) {
    var now = Date.now();
    if (busy || tries >= MAX_TRIES || now - lastTry < 4000) return;
    busy = true;
    tries += 1;
    lastTry = now;
    var routes = (window.theme && window.theme.routes) || {};
    fetch((routes.cartUpdate || '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: code, sections: sectionIds(), sections_url: window.location.pathname })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) { render(data.sections); paint(); })
      .catch(function () {})
      .finally(function () { busy = false; });
  }

  function paint() {
    var els = document.querySelectorAll('[data-deal-timer]');
    if (!els.length) return;

    var now = Date.now();
    var state = read();
    if (!state || !state.deadline) {
      state = { deadline: now + DURATION };
      write(state);
    }
    var left = state.deadline - now;
    var applied = els[0].getAttribute('data-applied') === 'true';

    if (left > 0 && !applied) setDiscount(CODE);
    if (left <= 0 && applied) setDiscount('');

    Array.prototype.forEach.call(els, function (el) {
      var text = el.querySelector('[data-deal-text]');
      var clock = el.querySelector('[data-deal-clock]');
      var expired = left <= 0;
      var mode = expired ? 'expired' : 'active';
      if (el.getAttribute('data-mode') !== mode) {
        el.setAttribute('data-mode', mode);
        el.classList.toggle('is-expired', expired);
        if (text) {
          text.innerHTML = expired
            ? 'Süre doldu. Sepette 150 TL indirim fırsatı sona erdi.'
            : 'Sepette <strong>150 TL indirimi</strong> kaçırma! Kalan süre:';
        }
      }
      if (clock) clock.textContent = expired ? '' : format(left);
      el.hidden = false;
    });
  }

  function init() {
    injectStyles();
    paint();
    window.setInterval(paint, 1000);
  }

  if (window.__oxbDealInit) return;
  window.__oxbDealInit = true;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
